function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30",
  height: "16",
  width: "16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.87 6.7l4.92-2.02c.91-.91.4-2.47-.87-2.66l-6.08-.93L1.79.02A1.57 1.57 0 000 1.8l1.08 7.03.92 6.07a1.57 1.57 0 002.67.88l1.94-4.71 20.63 18.28c.73.73 1.8.85 2.38.27.58-.58.46-1.63-.28-2.36L10.87 6.7",
  fill: "currentColor"
}));